import { ArrayValues } from 'type-fest';

import { TypographyVariant } from '../../../theme/generated/typography';

export const labelWeights = ['regular', 'medium'] as const;
export type LabelWeight = ArrayValues<typeof labelWeights>;

export const labelSizes = ['sm', 'md'] as const;
export type LabelSize = ArrayValues<typeof labelSizes>;

/**
 * Size + weight → Typography variant.
 *
 * The label look is variant-driven (font-size, line-height and weight all come
 * from the theme class), exactly like every other text component in the DS.
 */
export const labelSizeToVariant: Record<
  LabelSize,
  Record<LabelWeight, TypographyVariant>
> = {
  sm: { regular: 'P12R', medium: 'P12M' },
  md: { regular: 'P14R', medium: 'P14M' },
};

/**
 * Label first-line height per size — mirrors the P12R/P14R line-heights
 * (sm = 18px, md = 22px). Used by ControlLabel to pin the control cell to the
 * label's first line; the actual font metrics live on the theme variants.
 */
export const labelSizeToLineHeight: Record<LabelSize, number> = {
  sm: 18,
  md: 22,
};
